import { combineReducers } from "redux";
import { coursebuilder } from "./CourseBuilder";

export default combineReducers({
  
  coursebuilder: coursebuilder,
});
